import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const EmptyFolderHighDefinition = forwardRef<SVGSVGElement, IconProps>(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="98" height="80" viewBox="0 0 98 80" fill="none">
      <g filter="url(#filter0_d_4207_1586)">
        <mask
          id="path-1-outside-1_4207_1586"
          maskUnits="userSpaceOnUse"
          x="15.7942"
          y="8.75085"
          width="73"
          height="61"
          fill="black"
        >
          <rect fill="white" x="15.7942" y="8.75085" width="73" height="61" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.2449 10.7509C18.8914 10.7509 17.7942 11.8481 17.7942 13.2015V62.2763C17.7942 64.6869 19.5345 66.691 21.8272 67.1009C21.8735 67.1092 21.8735 67.1715 21.8267 67.1749H21.3976L21.5628 67.1804C21.6516 67.1833 21.7397 67.1814 21.8267 67.1749H22.5321C22.5863 67.1767 22.6408 67.1776 22.6955 67.1776H69.3388C69.3935 67.1776 69.448 67.1767 69.5023 67.1749H71.7391C72.8277 67.1749 73.7859 66.4568 74.0913 65.4119L86.2885 23.6879C86.7471 22.1192 85.5707 20.5496 83.9363 20.5496H81.7988C80.4391 20.5496 79.3128 19.5524 78.4045 18.5406C77.5072 17.541 76.205 16.9122 74.756 16.9122L49.6301 16.9122C48.3688 16.9122 47.2422 16.1233 46.8109 14.9381L46.1674 13.1698C45.6389 11.7175 44.2585 10.7509 42.713 10.7509L20.2449 10.7509Z"
          />
        </mask>
        <path
          d="M20.2449 10.7509L20.2449 12.7509L20.2449 10.7509ZM21.3976 67.1749V65.1749L21.3319 69.1739L21.3976 67.1749ZM21.5628 67.1804L21.4971 69.1793H21.4971L21.5628 67.1804ZM22.5321 67.1749L22.5976 65.176L22.5648 65.1749H22.5321V67.1749ZM69.5023 67.1749V65.1749H69.4695L69.4368 65.176L69.5023 67.1749ZM74.0913 65.4119L76.011 65.9731L76.011 65.9731L74.0913 65.4119ZM86.2885 23.6879L84.3689 23.1267V23.1267L86.2885 23.6879ZM74.756 16.9122V14.9122V16.9122ZM46.1674 13.1698L44.288 13.8537V13.8537L46.1674 13.1698ZM42.713 10.7509L42.713 12.7509L42.713 10.7509ZM46.8109 14.9381L48.6903 14.2542L46.8109 14.9381ZM78.4045 18.5406L76.9162 19.8766L78.4045 18.5406ZM21.8272 67.1009L21.4752 69.0697L21.8272 67.1009ZM19.7942 13.2015C19.7942 12.9526 19.996 12.7509 20.2449 12.7509L20.2449 8.75087C17.7868 8.75087 15.7942 10.7435 15.7942 13.2015H19.7942ZM19.7942 62.2763V13.2015H15.7942V62.2763H19.7942ZM22.1792 65.1322C20.8233 64.8898 19.7942 63.7011 19.7942 62.2763H15.7942C15.7942 65.6726 18.2456 68.4923 21.4752 69.0697L22.1792 65.1322ZM21.8267 65.1749H21.3976V69.1749H21.8267V65.1749ZM21.3319 69.1739L21.4971 69.1793L21.6284 65.1814L21.4632 65.176L21.3319 69.1739ZM21.4971 69.1793C21.6575 69.1846 21.817 69.1812 21.9749 69.1694L21.6785 65.1804C21.6624 65.1816 21.6457 65.182 21.6284 65.1814L21.4971 69.1793ZM22.5321 65.1749H21.8267V69.1749H22.5321V65.1749ZM22.6955 65.1776C22.6627 65.1776 22.63 65.1771 22.5976 65.176L22.4666 69.1739C22.5427 69.1764 22.619 69.1776 22.6955 69.1776V65.1776ZM69.3388 65.1776H22.6955V69.1776H69.3388V65.1776ZM69.4368 65.176C69.4043 65.1771 69.3717 65.1776 69.3388 65.1776V69.1776C69.4154 69.1776 69.4917 69.1764 69.5678 69.1739L69.4368 65.176ZM71.7391 65.1749H69.5023V69.1749H71.7391V65.1749ZM72.1717 64.8507C72.1155 65.0429 71.9393 65.1749 71.7391 65.1749V69.1749C73.7162 69.1749 75.4562 67.8707 76.011 65.9731L72.1717 64.8507ZM84.3689 23.1267L72.1717 64.8507L76.011 65.9731L88.2082 24.2491L84.3689 23.1267ZM83.9363 22.5496C84.2369 22.5496 84.4532 22.8382 84.3689 23.1267L88.2082 24.2491C89.041 21.4001 86.9046 18.5496 83.9363 18.5496V22.5496ZM81.7988 22.5496H83.9363V18.5496H81.7988V22.5496ZM74.756 18.9122C75.6136 18.9122 76.3822 19.2817 76.9162 19.8766L79.8928 17.2046C78.6322 15.8003 76.7965 14.9122 74.756 14.9122V18.9122ZM49.6301 18.9122L74.756 18.9122V14.9122L49.6301 14.9122V18.9122ZM44.288 13.8537L44.9315 15.6221L48.6903 14.2542L48.0468 12.4859L44.288 13.8537ZM42.713 12.7509C43.4177 12.7509 44.047 13.1916 44.288 13.8537L48.0468 12.4859C47.2308 10.2434 45.0993 8.75085 42.713 8.75085L42.713 12.7509ZM20.2449 12.7509L42.713 12.7509L42.713 8.75085L20.2449 8.75087L20.2449 12.7509ZM49.6301 14.9122C49.2096 14.9122 48.8341 14.6493 48.6903 14.2542L44.9315 15.6221C45.6503 17.5974 47.528 18.9122 49.6301 18.9122V14.9122ZM81.7988 18.5496C81.4017 18.5496 80.8073 18.2234 79.8928 17.2046L76.9162 19.8766C77.8182 20.8815 79.4766 22.5496 81.7988 22.5496V18.5496ZM21.4752 69.0697C20.5124 68.8976 19.8587 68.0567 19.8619 67.1328C19.8634 66.6898 20.0177 66.2092 20.3724 65.8185C20.7431 65.4104 21.2287 65.2139 21.6784 65.1804L21.9749 69.1694C22.448 69.1343 22.9513 68.9287 23.3336 68.5076C23.7001 68.1041 23.8603 67.6067 23.8618 67.1466C23.8652 66.1887 23.1883 65.3126 22.1792 65.1322L21.4752 69.0697Z"
          fill="white"
          mask="url(#path-1-outside-1_4207_1586)"
        />
      </g>
      <path
        d="M17.7942 13.2015C17.7942 11.8481 18.8914 10.7509 20.2449 10.7509L42.713 10.7509C44.2585 10.7509 45.6389 11.7175 46.1674 13.1698L47.5293 16.9122L74.756 16.9122C77.463 16.9122 79.6574 19.1066 79.6574 21.8136V27.1006C79.6574 27.7463 79.5298 28.3856 79.282 28.9819L74.6156 40.2085C74.3678 40.8048 74.2402 41.4441 74.2402 42.0897V62.2763C74.2402 64.9832 72.0458 67.1776 69.3388 67.1776H22.6955C19.9886 67.1776 17.7942 64.9832 17.7942 62.2763V13.2015Z"
        fill="url(#paint0_linear_4207_1586)"
      />
      <g filter="url(#filter1_di_4207_1586)">
        <path
          d="M32.192 22.5408C32.4126 21.3854 33.4229 20.5496 34.5992 20.5496H83.9363C85.5707 20.5496 86.7471 22.1192 86.2885 23.6879L74.0913 65.4119C73.7859 66.4568 72.8277 67.175 71.7391 67.175H21.3976L21.5628 67.1804C22.7688 67.22 23.8241 66.3758 24.0504 65.1906L32.192 22.5408Z"
          fill="url(#paint1_linear_4207_1586)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4207_1586"
          x="11.7942"
          y="5.75085"
          width="80.5956"
          height="68.4308"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4207_1586" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4207_1586" result="shape" />
        </filter>
        <filter
          id="filter1_di_4207_1586"
          x="0.566871"
          y="0.944245"
          width="96.8497"
          height="78.4908"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4.90134" dy="-3.67601" />
          <feGaussianBlur stdDeviation="7.96468" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4207_1586" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4207_1586" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.22534" dy="1.22534" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4207_1586" />
        </filter>
        <linearGradient
          id="paint0_linear_4207_1586"
          x1="46.0172"
          y1="9.31129"
          x2="46.0172"
          y2="67.1777"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#48B0E6" />
          <stop offset="1" stopColor="#0974BF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4207_1586"
          x1="53.5531"
          y1="20.5496"
          x2="53.5531"
          y2="67.2492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83E1FF" />
          <stop offset="1" stopColor="#38A2DF" />
        </linearGradient>
      </defs>
    </svg>
  )
})
